import { type IMarket, MarketStatus, SettlementResult } from "~/types/event";
import type { Platform } from "~/types/platform";
import { uniquePlatforms } from "~/utils/uniquePlatforms";

import type { MarketResult } from "./getMarketSettlement";

export interface ISettledGroup {
  result: MarketResult | null;
  platforms: Platform[];
}

export interface ISettledElsewhere {
  settled: ISettledGroup[];
  openPlatforms: Platform[];
}

const RESULT_ORDER: readonly (MarketResult | null)[] = [
  SettlementResult.YES,
  SettlementResult.NO,
  null,
];

const withStatus = (
  markets: readonly IMarket[],
  status: MarketStatus
): IMarket[] => markets.filter(({ unifiedStatus }) => unifiedStatus === status);

const groupByResult = (resolved: readonly IMarket[]): ISettledGroup[] =>
  RESULT_ORDER.map((result) => ({
    result,
    platforms: uniquePlatforms(
      resolved.filter((market) => market.result === result)
    ),
  })).filter(({ platforms }) => platforms.length > 0);

export const getSettledElsewhere = (
  markets: readonly IMarket[]
): ISettledElsewhere | null => {
  const resolved = withStatus(markets, MarketStatus.RESOLVED);
  const open = withStatus(markets, MarketStatus.ACTIVE);

  if (!resolved.length || !open.length) {
    return null;
  }

  return {
    settled: groupByResult(resolved),
    openPlatforms: uniquePlatforms(open),
  };
};
